import React from "react";
import Footer from "../Footer/Footer";
import logo from "../../assets/img/LogoCC.png";

class LayoutSinNavegacion extends React.Component {
  render() {
    return (
      <>
        <div>
          <div id="content">
            {/* <!-- Begin Page Content --> */}
            <div className="container-fluid">
              <div className="text-center">
                <div className="bg-primary mb-4">
                  <img src={logo} className="sidebar-brand-logo" />
                </div>
                <main>{this.props.children}</main>
              </div>
            </div>
            {/* <!-- /.container-fluid --> */}
          </div>
          {/* <!-- End of Main Content --> */}

          {/* <!--Componete de  Footer --> */}
          <Footer />
          {/* <!-- End of Footer --> */}
        </div>
      </>
    );
  }
}

export default LayoutSinNavegacion;
